import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatmodelsService {

  url = environment.serverAPI9 + "/api/models/verify";
  url1 = environment.serverAPI9 + "/api/chat-providers";
  url2 = environment.serverAPI11 + "/api/chat-providers";

  constructor(private http: HttpClient) { }

  getPresets(): Observable<any> {
    return this.http.get<any>(`${this.url2}/presets`);
  }

  discoverModels(payload: any): Observable<any> {
    return this.http.post<any>(`${this.url2}/discover-models`, payload);
  }

  verifyConnection(payload: any): Observable<any> {
    return this.http.post<any>(`${this.url2}/verify`, payload);
  }

  getProviderModels(providerId: any): Observable<any> {
    return this.http.get<any>(`${this.url2}/${providerId}/models`).pipe(
      catchError(() => this.http.get<any>(`${this.url1}/${providerId}/models`))
    );
  }

  verifykeys(payload: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, payload);
  }

  saveChatModel(payload: any): Observable<any> {
    if (payload.providerId) {
      return this.http.put<any>(`${this.url1}/${payload.providerId}`, payload).pipe(
        catchError(err => {
          console.warn('Failed on serverAPI9, continuing to serverAPI11:', err);
          return of(null);
        }),
        switchMap((res1: any) => {
          return this.http.put<any>(`${this.url2}/${payload.providerId}`, payload).pipe(
            catchError(err => {
              console.warn('Failed to update provider on secondary serverAPI11:', err);
              return of(null);
            }),
            map((res2: any) => res2 || res1)
          );
        })
      );
    } else {
      return this.http.post<any>(`${this.url2}`, payload).pipe(
        catchError(err => {
          console.warn('serverAPI11 direct create failed, trying serverAPI9:', err);
          return this.http.post<any>(`${this.url1}`, payload);
        }),
        switchMap((res2: any) => {
          const createdProvider = res2?.data || res2;
          const providerId = createdProvider?.providerId;
          if (providerId) {
            const payloadWithId = { ...payload, providerId };
            return this.http.post<any>(`${this.url1}`, payloadWithId).pipe(
              catchError(() => of(null)),
              map(() => res2)
            );
          }
          return of(res2);
        })
      );
    }
  }

  getProvidersDropdown(): Observable<any> {
    return this.http.get<any>(`${this.url2}/dropdown`).pipe(
      catchError(() => this.http.get<any>(`${this.url1}/dropdown`))
    );
  }

  deleteProvider(id: number): Observable<any> {
    return this.http.delete<any>(`${this.url2}/${id}`).pipe(
      catchError(() => of(null)),
      switchMap(() => {
        return this.http.delete<any>(`${this.url1}/${id}`).pipe(
          catchError(err => {
            console.warn('Failed to delete provider from serverAPI9:', err);
            return of(null);
          })
        );
      })
    );
  }

  aiEnhance(prompt: string, providerData: any): Observable<any> {
    const body: any = { 
      prompt, 
      ...providerData,
      provider_id: providerData?.providerId,
      api_url: providerData?.apiUrl,
      model: providerData?.models || providerData?.modelName,
      modelName: providerData?.models || providerData?.modelName
    };
    return this.http.post<any>(`${this.url1}/ai-enhance`, body);
  }
}
